import React from 'react'
import { ROUTE_TOOLS_COMPUTE_RADIUS } from '../../../routes'
import { selectCurrentHistoryRoute } from '../../../store/history/history.selectors'
import { hideMapPopup, displayMapPopup } from '../../../store/map/mapSlice'
import { selectAddresses, selectAddressContour } from '../../../store/address/address.selectors'
import { createCustomSelector } from '../../utils/react-reselect'
import { POPUP_TYPE_ADDRESS } from '../popup/popup.selectors'
import AddressMarker from './AddressMarker'
import { useDispatch, useSelector } from 'react-redux'
import { selectPopupType } from '../../../store/map/map.selectors'
import { useAction } from '../../utils/react-redux'
import { setAmbiguityAddress } from '../../../store/location/location.actions'

export const selectShouldDisplayMarkers = createCustomSelector(
  selectAddresses,
  selectAddressContour,
  selectCurrentHistoryRoute,
  (addresses, contour, historyRoute) =>
    Boolean(addresses?.length && !contour && historyRoute !== ROUTE_TOOLS_COMPUTE_RADIUS)
)

const AddressMarkersContainer = () => {
  const dispatch = useDispatch()
  const addresses = useSelector(selectAddresses)
  const popupType = useSelector(selectPopupType)
  const execSetAmbiguityAddress = useAction(setAmbiguityAddress)

  const handleClickMarker = address => () => {
    if (addresses.length > 1) {
      execSetAmbiguityAddress(address)
    } else {
      popupType === POPUP_TYPE_ADDRESS ? dispatch(hideMapPopup()) : dispatch(displayMapPopup(POPUP_TYPE_ADDRESS))
    }
  }

  const shouldDisplayMarkers = useSelector(selectShouldDisplayMarkers)
  if (!shouldDisplayMarkers) return <></>

  return (
    <div>
      {addresses.map(address => {
        const {
          coordinates: { lat, lng }
        } = address
        return <AddressMarker key={`${lng}-${lat}`} coordinates={{ lat, lng }} onClick={handleClickMarker(address)} />
      })}
    </div>
  )
}

export default AddressMarkersContainer
